import { FIELD_PATHS, TRUST_TYPE } from '@funnels/constants';
import { CompanyEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';

const OPTIONS = [
  { label: 'Cash management trust', value: TRUST_TYPE.CASH_MANAGEMENT_TRUST },
  { label: 'Discretionary trust', value: TRUST_TYPE.DISCRETIONARY_TRUST },
  { label: 'Fixed', value: TRUST_TYPE.FIXED },
  { label: 'Hybrid', value: TRUST_TYPE.HYBRID },
  { label: 'Superannuation trust', value: TRUST_TYPE.SUPERANNUATION_TRUSTS },
  { label: 'Unit', value: TRUST_TYPE.UNIT },
  { label: 'Other', value: TRUST_TYPE.OTHER },
];

interface BusinessTrustTypeProps extends CompanyEntityIndex {
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const BusinessTrustType = (props: BusinessTrustTypeProps) => {
  const { companyIndex, ...rest } = props;

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.COMPANY_TRUST_TYPE(companyIndex)}
      label="Type of trust"
      options={OPTIONS}
    />
  );
};
